import React, { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import {
  FormErrorMessage,
  FormLabel,
  FormControl,
  Input,
  Button,
  Box,
  useToast,
  IconButton,
} from '@chakra-ui/react';

import { HttpContext } from '../../context/HttpContext';
import { getErrors, getMessage } from '../../util';
import EditSelectCurrency from '../../common/UIcomponents/EditSelectCurrency';
import CampaignEditDatePicker from './CampaignEditDatePicker';
import { CampaignContext } from '../../context/campaign/FilterCampaigns';
import moment from 'moment';
import EditSelectStatus from '../../common/UIcomponents/EditSelectStatus';
import UploadFiles from './UploadCampaignFile';
import { getFilenameFromResponse } from '../vendors/UploadedFile';
import { CheckIcon, CloseIcon } from '@chakra-ui/icons';
// import SelectPodLeader from '../../common/UIcomponents/SelectPodLeader';

const CampaignEditStatusForm = ({ onClose, campaign, updateCampaign }) => {
  const [fileName] = useState(campaign.file);
  const [fileName2] = useState(campaign.file2);
  const [fileName3] = useState(campaign.file3);
  const [fileName4] = useState(campaign.file4);
  const [fileName5] = useState(campaign.file5);
  const [file, setFile] = useState(null);
  const [file2, setFile2] = useState(null);
  const [file3, setFile3] = useState(null);
  const [file4, setFile4] = useState(null);
  const [file5, setFile5] = useState(null);
  const [isFileRemoved, setIsFileRemoved] = useState(false);
  const [isFileRemoved2, setIsFileRemoved2] = useState(false);
  const [isFileRemoved3, setIsFileRemoved3] = useState(false);
  const [isFileRemoved4, setIsFileRemoved4] = useState(false);
  const [isFileRemoved5, setIsFileRemoved5] = useState(false);

  const [newFile, setNewFile] = useState(undefined);
  const [newFile2, setNewFile2] = useState(undefined);
  const [newFile3, setNewFile3] = useState(undefined);
  const [newFile4, setNewFile4] = useState(undefined);
  const [newFile5, setNewFile5] = useState(undefined);
  const [currencyId, setCurrencyId] = React.useState(campaign.currency.id);
  const [startDate, setStartDate] = useState(campaign.startDate);
  const [endDate, setEndDate] = useState(campaign.endDate);
  const [status, setStatus] = useState(campaign.status);
  const [done, setDone] = React.useState(false);
  // const [podLeaderId, setPodLeaderId] = React.useState(campaign?.podLeader?.id || 0);

  const { authAxios } = useContext(HttpContext);
  const toast = useToast();

  useEffect(() => {
    const getData = async () => {
      try {
        if (campaign.file) {
          const response = await authAxios.get(
            `files/download?id=${campaign.id}&type=campaign`,
            { responseType: 'blob' }
          );

          const blob = new Blob([response.data], {
            type: response.headers['content-type'],
          });

          const file = new File([blob], getFilenameFromResponse(response), {
            type: blob.type,
          });
          Object.assign(file, { preview: URL.createObjectURL(file) });
          setFile(file);
        }

        if (campaign.file2) {
          const response2 = await authAxios.get(
            `files/download?id=${campaign.id}&type=campaignFile2`,
            { responseType: 'blob' }
          );

          const blob = new Blob([response2.data], {
            type: response2.headers['content-type'],
          });

          const file2 = new File([blob], getFilenameFromResponse(response2), {
            type: blob.type,
          });
          Object.assign(file2, { preview: URL.createObjectURL(file2) });
          setFile2(file2);
        }

        if (campaign.file3) {
          const response3 = await authAxios.get(
            `files/download?id=${campaign.id}&type=campaignFile3`,
            { responseType: 'blob' }
          );

          const blob = new Blob([response3.data], {
            type: response3.headers['content-type'],
          });

          const file3 = new File([blob], getFilenameFromResponse(response3), {
            type: blob.type,
          });
          Object.assign(file3, { preview: URL.createObjectURL(file3) });
          setFile3(file3);
        }

        if (campaign.file4) {
          const response4 = await authAxios.get(
            `files/download?id=${campaign.id}&type=campaignFile4`,
            { responseType: 'blob' }
          );

          const blob = new Blob([response4.data], {
            type: response4.headers['content-type'],
          });

          const file4 = new File([blob], getFilenameFromResponse(response4), {
            type: blob.type,
          });
          Object.assign(file4, { preview: URL.createObjectURL(file4) });
          setFile4(file4);
        }

        if (campaign.file5) {
          const response5 = await authAxios.get(
            `files/download?id=${campaign.id}&type=campaignFile5`,
            { responseType: 'blob' }
          );

          const blob = new Blob([response5.data], {
            type: response5.headers['content-type'],
          });

          const file5 = new File([blob], getFilenameFromResponse(response5), {
            type: blob.type,
          });
          Object.assign(file5, { preview: URL.createObjectURL(file5) });
          setFile5(file5);
        }
      } catch (onError) {
        console.log(onError);
      }
    };

    getData();
  }, [authAxios]);

  const {
    register,
    handleSubmit,
    formState,
    // clearErrors,
    setError,
    reset,
    setValue,
    watch,
  } = useForm({
    mode: 'onChange',
  });
  const { errors, isSubmitting, isDirty, isValid } = formState;

  const watchClientName = watch('clientName');

  const onSubmit = async (values) => {
    try {
      let data = values;

      if (status && status !== 'initial') {
        data = {
          ...data,
          status,
        };
      }

      const res = await authAxios.patch(`/campaigns/${campaign.id}/change-status`, data);
      updateCampaign({ campaign: res.data.data, meta: res.data.meta });
      onClose();
      reset();
      setDone(true);
      let description = 'You have successfully change the campaign status.';
      if (status !== 'initial') {
        description = 'You have successfully requested campaign changes.';
      }
      toast({
        position: 'top',
        description,
        status: 'success',
        duration: 6000,
        isClosable: true,
      });
    } catch (onError) {
      const errors = getErrors(onError);

      if (errors && errors.status && errors.status.errors) {
        const message = errors.status.errors[0];
        setError('status', { type: 'server', message });
      } else {
        let msgsArr = onError?.response?.data?.errors?.errors || [];
        if (msgsArr.length > 0) {
          toast({
            position: 'top-left',
            description: msgsArr[0],
            status: 'error',
            duration: 6000,
            isClosable: true,
          });
        } else {
          const message = getMessage(onError);
          console.log({ message });
          if (message) {
            toast({
              position: 'top-left',
              description: message,
              status: 'error',
              duration: 6000,
              isClosable: true,
            });
          }
        }
      }
    }
  };
  const { setFrom } = useContext(CampaignContext);
  const { setTo } = useContext(CampaignContext);

  function handleOnClose() {
    setFrom('');
    setTo('');
    onClose();
  }

  const updateCurrencyId = (id) => {
    setCurrencyId(id);
  };

  const updateStatus = (status) => {
    setStatus(status);
  };
  function updateStartDate(date) {
    setStartDate(moment(date).format('YYYY-MM-DD'));
  }

  function updateEndDate(date) {
    setEndDate(moment(date).format('YYYY-MM-DD'));
  }

  function isChangedDate() {
    return !(startDate === campaign.startDate && endDate === campaign.endDate);
  }

  function updateUploadedFile(file) {
    setValue('clientName', watchClientName, { shouldDirty: true });
    setNewFile(file);
    setIsFileRemoved(false);
  }

  function updateUploadedFile2(file) {
    setNewFile2(file);
    setIsFileRemoved2(false);
  }

  function updateUploadedFile3(file) {
    setNewFile3(file);
    setIsFileRemoved3(false);
  }
  function updateUploadedFile4(file) {
    setNewFile4(file);
    setIsFileRemoved4(false);
  }
  function updateUploadedFile5(file) {
    setNewFile5(file);
    setIsFileRemoved5(false);
  }

  // const updatePodLeaderId = (id) => {
  //   if (id === '0') {
  //     setError('podLeader', { type: 'custom', message: 'This is mandatory field' });
  //   } else {
  //     clearErrors('podLeader');
  //   }
  //   setPodLeaderId(id);
  // };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormControl isInvalid={errors.clientName} mb={[4, 4, 8]}>
          <FormLabel htmlFor="emailHtmlFor" color="#c3c1c1">
            Client
          </FormLabel>
          <Input
            isInvalid
            name="clientName"
            id="clientName"
            disabled
            color="#c3c1c1"
            defaultValue={campaign.clientName}
            placeholder="Enter client name"
            focusBorderColor="black"
            errorBorderColor="error.500"
          />
          <FormErrorMessage>
            {errors.clientName?.message || errors.clientName}
          </FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={errors.campaignName} mb={[4, 4, 8]}>
          <FormLabel htmlFor="emailHtmlFor" color="#c3c1c1">
            Campaign name
          </FormLabel>
          <Input
            isInvalid
            name="campaignName"
            id="campaignName"
            disabled
            color="#c3c1c1"
            defaultValue={campaign.campaignName}
            placeholder="Enter campaign Name"
            focusBorderColor="black"
            errorBorderColor="error.500"
            {...register('campaignName')}
          />
          <FormErrorMessage>
            {errors.campaignName?.message || errors.campaignName}
          </FormErrorMessage>
        </FormControl>
        {campaign?.status !== 'initial' && (
          <FormControl isInvalid={errors.status} mb={[4, 4, 8]}>
            <FormLabel htmlFor="emailHtmlFor">Status</FormLabel>
            <EditSelectStatus status={status} updateStatus={updateStatus} />
            <FormErrorMessage>{errors.status?.message || errors.status}</FormErrorMessage>
          </FormControl>
        )}
        <CampaignEditDatePicker
          startDate={campaign.startDate}
          endDate={campaign.endDate}
          updateStartDate={updateStartDate}
          updateEndDate={updateEndDate}
          disabled
        />

        <FormControl isInvalid={errors.currency} mb={[4, 4, 8]}>
          <FormLabel htmlFor="emailHtmlFor" color="#c3c1c1">
            Currency
          </FormLabel>
          <EditSelectCurrency
            currencyId={currencyId}
            updateCurrencyId={updateCurrencyId}
            disabled
          />
          <FormErrorMessage>
            {errors.currency?.message || errors.currency}
          </FormErrorMessage>
        </FormControl>
        <FormControl isInvalid={errors.budget} mb={[4, 4, 8]}>
          <FormLabel htmlFor="emailHtmlFor" color="#c3c1c1">
            Budget
          </FormLabel>
          <Input
            disabled
            color="#c3c1c1"
            isInvalid
            name="budget"
            id="budget"
            defaultValue={campaign.budget}
            placeholder="Enter net amount"
            focusBorderColor="black"
            errorBorderColor="error.500"
            {...register('budget')}
          />
          <FormErrorMessage>{errors.budget?.message || errors.budget}</FormErrorMessage>
        </FormControl>
        {/*<FormControl isInvalid={errors.podLeader} mb={[4, 4, 8]}>*/}
        {/*  <FormLabel htmlFor="emailHtmlFor" color="#c3c1c1">*/}
        {/*    Pod Leader*/}
        {/*  </FormLabel>*/}
        {/*  <SelectPodLeader*/}
        {/*    updatePodLeaderId={updatePodLeaderId}*/}
        {/*    podLeaderId={podLeaderId}*/}
        {/*    disabled*/}
        {/*  />*/}
        {/*  <FormErrorMessage>*/}
        {/*    {errors.podLeader?.message || errors.podLeader}*/}
        {/*  </FormErrorMessage>*/}
        {/*</FormControl>*/}

        <FormLabel htmlFor="emailHtmlFor" color="#c3c1c1">
          Attach a documents (optional)
        </FormLabel>
        <Box color="#868789" fontSize="14px">
          Document 1.
        </Box>
        {newFile === undefined && campaign.file && !isFileRemoved && (
          <Box
            position="relative"
            p={2}
            border="1px solid #ebecf0"
            borderRadius="4px"
            mt={2}
            mb={4}
          >
            <Box pr="10px">
              <Box key={file?.name}>
                {/* {file.path} - {formatBytes(file.size)} */}
                {/* <Link color="brand.400" ml="5px">File uploaded</Link> */}
                <Box color="brand.400" ml="5px">
                  <CheckIcon color="brand.400" mr={2} />{' '}
                  <a href={file?.preview} target="_blank" rel="noreferrer">
                    {fileName ? fileName : 'Uploaded file'}
                  </a>{' '}
                </Box>
              </Box>
            </Box>
            <Box position="absolute" top="-12px" right="-10px">
              <IconButton
                disabled
                colorScheme="brand"
                size="xs"
                onClick={() => {
                  setIsFileRemoved(true);
                  setValue('clientName', watchClientName, {
                    shouldDirty: true,
                  });
                }}
                aria-label="remove file icon"
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
        )}
        <UploadFiles
          updateUploadedFile={updateUploadedFile}
          removeFile={() => setIsFileRemoved(true)}
          name={file}
          disabled
        />

        <Box color="#868789" fontSize="14px">
          Document 2.
        </Box>
        {newFile2 === undefined && campaign.file2 && !isFileRemoved2 && (
          <Box
            position="relative"
            p={2}
            border="1px solid #ebecf0"
            borderRadius="4px"
            mt={2}
            mb={4}
          >
            <Box pr="10px">
              <Box key={file2?.name}>
                {/* {file.path} - {formatBytes(file.size)} */}
                {/* <Link color="brand.400" ml="5px">File uploaded</Link> */}
                <Box color="brand.400" ml="5px">
                  <CheckIcon color="brand.400" mr={2} />{' '}
                  <a href={file2?.preview} target="_blank" rel="noreferrer">
                    {fileName2 ? fileName2 : 'Uploaded file'}
                  </a>{' '}
                </Box>
              </Box>
            </Box>
            <Box position="absolute" top="-12px" right="-10px">
              <IconButton
                disabled
                colorScheme="brand"
                size="xs"
                onClick={() => {
                  setIsFileRemoved2(true);
                  setValue('clientName', watchClientName, {
                    shouldDirty: true,
                  });
                }}
                aria-label="remove file icon"
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
        )}
        <UploadFiles
          updateUploadedFile={updateUploadedFile2}
          removeFile={() => setIsFileRemoved2(true)}
          name={file2}
          disabled
        />
        <Box color="#868789" fontSize="14px">
          Document 3.
        </Box>
        {newFile3 === undefined && campaign.file3 && !isFileRemoved3 && (
          <Box
            position="relative"
            p={2}
            border="1px solid #ebecf0"
            borderRadius="4px"
            mt={2}
            mb={4}
          >
            <Box pr="10px">
              <Box key={file3?.name}>
                {/* {file.path} - {formatBytes(file.size)} */}
                {/* <Link color="brand.400" ml="5px">File uploaded</Link> */}
                <Box color="brand.400" ml="5px">
                  <CheckIcon color="brand.400" mr={2} />{' '}
                  <a href={file3?.preview} target="_blank" rel="noreferrer">
                    {fileName3 ? fileName3 : 'Uploaded file'}
                  </a>{' '}
                </Box>
              </Box>
            </Box>
            <Box position="absolute" top="-12px" right="-10px">
              <IconButton
                disabled
                colorScheme="brand"
                size="xs"
                onClick={() => {
                  setIsFileRemoved3(true);
                  setValue('clientName', watchClientName, {
                    shouldDirty: true,
                  });
                }}
                aria-label="remove file icon"
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
        )}
        <UploadFiles
          updateUploadedFile={updateUploadedFile3}
          removeFile={() => setIsFileRemoved3(true)}
          name={file3}
          disabled
        />
        <Box color="#868789" fontSize="14px">
          Document 4.
        </Box>
        {newFile4 === undefined && campaign.file4 && !isFileRemoved4 && (
          <Box
            position="relative"
            p={2}
            border="1px solid #ebecf0"
            borderRadius="4px"
            mt={2}
            mb={4}
          >
            <Box pr="10px">
              <Box key={file4?.name}>
                {/* {file.path} - {formatBytes(file.size)} */}
                {/* <Link color="brand.400" ml="5px">File uploaded</Link> */}
                <Box color="brand.400" ml="5px">
                  <CheckIcon color="brand.400" mr={2} />{' '}
                  <a href={file4?.preview} target="_blank" rel="noreferrer">
                    {fileName4 ? fileName4 : 'Uploaded file'}
                  </a>{' '}
                </Box>
              </Box>
            </Box>
            <Box position="absolute" top="-12px" right="-10px">
              <IconButton
                disabled
                colorScheme="brand"
                size="xs"
                onClick={() => {
                  setIsFileRemoved4(true);
                  setValue('clientName', watchClientName, {
                    shouldDirty: true,
                  });
                }}
                aria-label="remove file icon"
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
        )}
        <UploadFiles
          updateUploadedFile={updateUploadedFile4}
          removeFile={() => setIsFileRemoved4(true)}
          name={file4}
          disabled
        />
        <Box color="#868789" fontSize="14px">
          Document 5.
        </Box>
        {newFile5 === undefined && campaign.file5 && !isFileRemoved5 && (
          <Box
            position="relative"
            p={2}
            border="1px solid #ebecf0"
            borderRadius="4px"
            mt={2}
            mb={4}
          >
            <Box pr="10px">
              <Box key={file5?.name}>
                {/* {file.path} - {formatBytes(file.size)} */}
                {/* <Link color="brand.400" ml="5px">File uploaded</Link> */}
                <Box color="brand.400" ml="5px">
                  <CheckIcon color="brand.400" mr={2} />{' '}
                  <a href={file5?.preview} target="_blank" rel="noreferrer">
                    {fileName5 ? fileName5 : 'Uploaded file'}
                  </a>{' '}
                </Box>
              </Box>
            </Box>
            <Box position="absolute" top="-12px" right="-10px">
              <IconButton
                disabled
                colorScheme="brand"
                size="xs"
                onClick={() => {
                  setIsFileRemoved5(true);
                  setValue('clientName', watchClientName, {
                    shouldDirty: true,
                  });
                }}
                aria-label="remove file icon"
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </Box>
        )}
        <UploadFiles
          updateUploadedFile={updateUploadedFile5}
          removeFile={() => setIsFileRemoved5(true)}
          name={file5}
          disabled
        />

        <>
          <Box display="flex" justifyContent="flex-end" mt={20} mb={20}>
            <Button
              type="submit"
              size="lg"
              colorScheme="brand"
              disabled={
                (!isDirty || !isValid || isSubmitting) &&
                currencyId === campaign.currency.id &&
                // (podLeaderId === 0 || podLeaderId === campaign?.podLeader?.id) &&
                status === campaign.status &&
                !isChangedDate()
              }
              isLoading={isSubmitting && !done}
              textTransform="initial"
              _hover={{ bg: '#000' }}
              borderRadius="10px"
              mr="10px"
            >
              Submit
            </Button>
            <Button
              variant="ghost"
              size="lg"
              colorScheme="brand"
              textTransform="initial"
              borderRadius="10px"
              onClick={handleOnClose}
              disabled={isSubmitting}
            >
              Cancel
            </Button>
          </Box>
        </>
      </form>
    </>
  );
};
export default CampaignEditStatusForm;
